import {
	CLEAR_ADMIN_MANAGEMENT_STATE,
	GET_ALL_ADMINS,
	GET_ALL_ADMINS_SUCCESS,
	GET_ALL_ADMINS_ERROR,
	GET_ADMIN_BY_ID,
	GET_ADMIN_BY_ID_SUCCESS,
	GET_ADMIN_BY_ID_ERROR,
	CREATE_ADMIN,
	CREATE_ADMIN_SUCCESS,
	CREATE_ADMIN_ERROR,
	UPDATE_ADMIN,
	UPDATE_ADMIN_SUCCESS,
	UPDATE_ADMIN_ERROR,
	DELETE_ADMIN,
	DELETE_ADMIN_SUCCESS,
	DELETE_ADMIN_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const ADMIN_URL = '/users-admin';
const USER_URL = '/users';

const defaultState = () => ({
	adminList: [],
	isLoadingAdmins: '',
});

const state = defaultState();

const getters = {
	adminList: (state) => state.adminList,
	isLoadingAdmins: (state) => state.isLoadingAdmins === 'loading',
};

const mutations = {
	[CLEAR_ADMIN_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_ADMINS]: (state) => {
		state.isLoadingAdmins = 'loading';
	},
	[GET_ALL_ADMINS_SUCCESS]: (state, data) => {
		state.adminList = data;
		state.isLoadingAdmins = 'success';
	},
	[GET_ALL_ADMINS_ERROR]: (state) => {
		state.isLoadingAdmins = 'error';
	},
	[GET_ADMIN_BY_ID]: (state) => {
		state.isLoadingAdmins = 'loading';
	},
	[GET_ADMIN_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingAdmins = 'success';
	},
	[GET_ADMIN_BY_ID_ERROR]: (state) => {
		state.isLoadingAdmins = 'error';
	},
	[CREATE_ADMIN]: (state) => {
		state.isLoadingAdmins = 'loading';
	},
	[CREATE_ADMIN_SUCCESS]: (state, data) => {
		state.isLoadingAdmins = 'success';
	},
	[CREATE_ADMIN_ERROR]: (state) => {
		state.isLoadingAdmins = 'error';
	},
	[UPDATE_ADMIN]: (state) => {
		state.isLoadingAdmins = 'loading';
	},
	[UPDATE_ADMIN_SUCCESS]: (state, data) => {
		state.isLoadingAdmins = 'success';
	},
	[UPDATE_ADMIN_ERROR]: (state) => {
		state.isLoadingAdmins = 'error';
	},
	[DELETE_ADMIN]: (state) => {
		state.isLoadingAdmins = 'loading';
	},
	[DELETE_ADMIN_SUCCESS]: (state, data) => {
		state.isLoadingAdmins = 'success';
	},
	[DELETE_ADMIN_ERROR]: (state) => {
		state.isLoadingAdmins = 'error';
	},
};

const actions = {
	[GET_ALL_ADMINS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_ADMINS);
			localStorage.setItem(`lastReqAdm`, 'configManagement/GET_ALL_ADMINS');

			http({
				method: 'GET',
				url: `${ADMIN_URL}/all-users${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_ADMINS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_ADMINS_ERROR);
				});
		});
	},
	[GET_ADMIN_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ADMIN_BY_ID);

			http({
				method: 'GET',
				url: `${USER_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ADMIN_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ADMIN_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_ADMIN]: async ({ commit }, { vm, body, timestamp }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_ADMIN);

			http.defaults.headers.common.timestamp = timestamp;

			http({
				method: 'POST',
				url: `${ADMIN_URL}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Administrador criado com sucesso.');
					commit(CREATE_ADMIN_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_ADMIN_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_ADMIN]: async ({ commit }, { vm, id, body, timestamp }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_ADMIN);

			http.defaults.headers.common.timestamp = timestamp;

			http({
				method: 'PATCH',
				url: `${ADMIN_URL}/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Administrador editado com sucesso.');
					commit(UPDATE_ADMIN_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_ADMIN_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_ADMIN]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_ADMIN);

			http({
				method: 'DELETE',
				url: `${USER_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Administrador excluído com sucesso.');
					commit(DELETE_ADMIN_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_ADMIN_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
